module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-backplates-remnants.6ffef79c.png";